import { ClientResetPasswordEmailRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

// Client Portal "forgot password". Unauthenticated; the backend answers Success whether or not
// the username exists (no enumeration), so a Success here means "if that user exists, an email
// went out" — and anything else must be surfaced instead of a false "Email Sent".
export default function useRequestClientPasswordReset() {
  const [submitting, setSubmitting] = useState(false);

  async function requestPasswordReset(params: ClientResetPasswordEmailRequest) {
    try {
      setSubmitting(true);
      const res = await api.postClientResetPasswordEmail(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  }

  return { submitting, requestPasswordReset };
}
